import axios from "axios";
import { req, reqF } from "./axiosFun";

/**
 * 审批流
 **/
// 获取开始审批人
export const GetApproverUser = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/GetApproverUser", params);
};
// 创建工作流开始
export const CreateWorkflowInstance = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/CreateWorkflowInstance", params);
};
// 批量创建工作流开始
export const CreateWorkflowInstanceList = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/CreateWorkflowInstanceList", params);
};
// 获取发起人在执行的审批
export const GetInstanceByUser = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/GetInstanceByUser", params);
};
// 撤销审批
export const KillWorkflow = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/Kill", params);
};
// 获取当前任务
export const GetPagePending = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/GetPagePending", params);
};
// 工作流流转
export const WorkflowJump = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/WorkflowJump", params);
};

// 批量审批
export const JumpList = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/JumpList", params);
};

// 获取审批记录List
export const GetRecordList = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/GetRecordList", params);
};
// 获取最新审批记录 | 最后一条
export const GetRecordLast = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/GetRecordLast", params);
};
// 获取下一步审批人
export const GetNextApproverUsers = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/GetNextApproverUsers", params);
};

// 创建评论
export const AddComments = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/AddComments", params);
};

// 列表
export const GetStructureDataList = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/GetStructureDataList", params);
};
// 添加编辑
export const SaveStructure = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/UpdateStructure", params);
};
// 修改工作流状态
export const UpdateStructureStatus = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/UpdateStructureStatus", params);
};
// 删除
export const DeleteStructure = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/DeleteStructure", params);
};
// 业务下拉
export const GetWorkFlowBusinessList = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/GetWorkFlowBusinessList", params);
};
// 业务列表
export const GetWorkFlowBusinessPageList = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/GetWorkFlowBusinessPageList", params);
};
// 业务保存
export const SaveWorkFlowBusiness = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/SaveWorkFlowBusiness", params);
};
// 业务删除
export const DeleteWorkFlowBusiness = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/DeleteWorkFlowBusiness", params);
};

// 获取送审时模板
export const GetSubmitStructure = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/GetSubmitStructure", params);
};

// 送审
export const CreateWorkflow = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/CreateWorkflow", params);
};
// 获取流程步骤
export const GetProcessList = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/GetProcessList", params);
};
// 获取流程步骤
export const GetNodeList = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/GetNodeList", params);
};

// 增加审批类型
export const SaveWorkFlowType = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/SaveWorkFlowType", params);
};
// 分页查询审批类型
export const GetdWorkFlowTypePageList = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/GetdWorkFlowTypePageList", params);
};
// 删除审批类型
export const DeleteWorkFlowType = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/DeleteWorkFlowType", params);
};
// 获取审批类型集合
export const GetWorkFlowTypeList = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/GetWorkFlowTypeList", params);
};
// 根据keyid 获取审批类型
export const GetWorkFlowTypeByID = (params) => {
	return reqF("post", "/api/sysConfig/WorkFlow/GetWorkFlowTypeByID", params);
};
